import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";


const baseName = "Bikes";
const firebaseDb = firebases.database().ref().child('Bikes');
const header = [{"field":"name","label":"Name","sort":"asc","type":"TEXT","editType":"text"},{"field":"image","label":"BikeImage","sort":"asc","type":"IMAGE","editType":"file"},{"field":"description","label":"description","sort":"asc","type":"TEXT","editType":"textview"},{"label":"Actions","field":"actions","sort":"asc","width":110,"type":"ACTIONS"}];
let context = null;

const BikesAdd = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Bikes" subtitle="Add New Bikes" sm="4" className="text-sm-left" />
    </Row>
    <Row>
    
      <Col lg="10">
        <FormItem title="Bikes Details" model={header} action="Add New Bikes" firebaseDb={firebaseDb} firebaseStorage={files}/>
      </Col>
    </Row>
  </Container>
);

export default BikesAdd;
